import React, { useEffect, useState } from "react";
import { getEquityData } from "../services/api.js";
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from "recharts";

export default function EquityChart({ period='month' }){
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(()=>{
    (async()=>{
      try{
        setLoading(true); setError("");
        setData(await getEquityData(period));
      }catch(e){ setError(e.message||"Fehler"); }
      finally{ setLoading(false); }
    })();
  },[period]);

  return (
    <div>
      <div style={{width:'100%',height:300}}>
        <ResponsiveContainer>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="equity" stroke="#2563eb" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      {loading && <div className="text-sm opacity-70 mt-2">Lade…</div>}
      {error && <div className="text-sm text-red-600 mt-2">{error}</div>}
    </div>
  );
}